import React from 'react';
import AdvancementIcon from '../../../../../../PulseCheck/img/advancement.svg';
import EngagementIcon from '../../../../../../PulseCheck/img/engagement.svg';
import HappinessIcon from '../../../../../../PulseCheck/img/happiness.svg';
import RelationshipsIcon from '../../../../../../PulseCheck/img/relationships.svg';
import StrengthIcon from '../../../../../../PulseCheck/img/strength.svg';
import TruthIcon from '../../../../../../PulseCheck/img/truth.svg';
import { Text, TextProps } from '../../../../../../CommonComponents/OPL/Text/Text';
import { PulseCheckCategory } from '../../../../../types/goalsDTO';

export const PULSE_CHECK_CATEGORY_ICON_MAP = {
  [PulseCheckCategory.Happiness]: HappinessIcon,
  [PulseCheckCategory.Engagement]: EngagementIcon,
  [PulseCheckCategory.Advancement]: AdvancementIcon,
  [PulseCheckCategory.Relationships]: RelationshipsIcon,
  [PulseCheckCategory.Truth]: TruthIcon,
  [PulseCheckCategory.Strength]: StrengthIcon,
};

interface Props extends TextProps {
  category: PulseCheckCategory;
}

export const PulseCheckCategoryIcon = ({ category, ...rest }: Props) => {
  const Icon = PULSE_CHECK_CATEGORY_ICON_MAP[category];

  return (
    <Text color="neutral.500" width={18} {...rest}>
      <Icon />
    </Text>
  );
};
